export type AdultShowAdMode = 'on' | 'off';
export type AdultShowAdModeYN = 'Y' | 'N';

interface AdultShowAdModeEligibilityInput {
  isLogin: boolean;
  isAdult: boolean;
  mode?: string;
  presetCode?: string;
}

interface AttachAdultShowAdModeParamIfEligibleInput {
  isResolved: boolean;
  adultShowAdMode: AdultShowAdMode;
  adultToggleShow: boolean;
}

export const canUseAdultShowAdMode = ({ isLogin, isAdult, mode, presetCode }: AdultShowAdModeEligibilityInput) => {
  if (!isLogin) return false;

  return (isAdult && ['ad', 'v'].includes(mode as string)) || (!isAdult && presetCode === 'pandatv');
};

export const isAdultShowAdModeToggleActive = ({
  isAdult,
  mode,
}: Pick<AdultShowAdModeEligibilityInput, 'isAdult' | 'mode'>) => isAdult && ['ad', 'v'].includes(mode as string);

export const toAdultShowAdModeYN = (adultShowAdMode: AdultShowAdMode): AdultShowAdModeYN =>
  adultShowAdMode === 'on' ? 'Y' : 'N';

export const attachAdultShowAdModeParamIfEligible = <T extends { adultShowAdModeYN?: AdultShowAdModeYN }>(
  params: T,
  { isResolved, adultShowAdMode, adultToggleShow }: AttachAdultShowAdModeParamIfEligibleInput,
) => {
  const { adultShowAdModeYN: _adultShowAdModeYN, ...baseParams } = params;

  if (!isResolved || !adultToggleShow) {
    return baseParams as T;
  }

  return {
    ...baseParams,
    adultShowAdModeYN: toAdultShowAdModeYN(adultShowAdMode),
  } as T;
};
